
<div class="unsub_page">
    <div class="unsub_box">
    
    <div *ngIf="!showThankyou"  class="cont_container">
    <div class="unsubc_confirm_text">{{middleContent?.text1}}</div>
    <div class="unsubs_button_parent">
        <button class="unsubc_button" [ngClass]="isUnsubscribed?'disable_unsub':''" [disabled]="isUnsubscribed" (click)="unsubscribeReminder()">{{middleContent?.title}}</button>
    </div>
    </div>
    

    <div *ngIf="showThankyou" class="unsub_thankyou">{{middleContent?.text2}}</div>
    </div>
</div>